import { SummaryFeatureList } from '~app/pages/Pricing/transformers/summary/types';
import AdvantageFeatureList from './advantageFeatureList';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const PremierFeatureList: SummaryFeatureList = [
  'grow_2792_a_b_testing',
  'sentiment',
  'response_quality_enabled',
  'crosstabs',
  'extended_piping',
  'click_map_qt',
];

export default [...AdvantageFeatureList, ...PremierFeatureList];
